if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-whatsapp-share]');

  if (!button) return;

  event.preventDefault();

  const productTitle = button.dataset.productTitle;
  const productUrl = button.dataset.productUrl;
  const defaultVariantId = button.dataset.defaultVariantId;

  // First check URL for selected variant
  const urlParams = new URLSearchParams(window.location.search);
  let selectedVariantId = urlParams.get('variant');

  // If no variant in URL, use default/first available variant
  if (!selectedVariantId) {
    selectedVariantId = defaultVariantId;
  }

  if (!selectedVariantId) {
    console.error('WhatsApp Share: No variant ID available');
    return;
  }

  let variants = [];

  try {
    variants = JSON.parse(
      button.dataset.whatsappVariants || '[]'
    );
  } catch (error) {
    console.error(
      'WhatsApp Share: Could not read variants',
      error
    );
    return;
  }

  const variant = variants.find(function (item) {
    return String(item.id) === String(selectedVariantId);
  });

  if (!variant) {
    console.error(
      'WhatsApp Share: Selected variant not found',
      selectedVariantId
    );
    return;
  }

  let message = `Check out ${productTitle}`;

  if (
    variant.title &&
    variant.title !== 'Default Title'
  ) {
    message += `\nVariant: ${variant.title}`;
  }

  if (variant.sku) {
    message += `\nSKU: ${variant.sku}`;
  }

  message += `\n\nProduct link: ${productUrl}`;

  // Only add variant parameter when it is actually a variant product
  if (variant.title && variant.title !== 'Default Title') {
    message += `?variant=${variant.id}`;
  }

  const whatsappUrl =
    'https://wa.me/?text=' +
    encodeURIComponent(message);

  window.open(whatsappUrl, '_blank');
});